module.exports = __webpack_public_path__ + "app-static/img/icon-lr.0aeefd5d.png";